import { useContext } from 'react';
import { RouterContext } from 'next/dist/shared/lib/router-context.shared-runtime';

// copy of useRouter that doesn't throw an error which can be used in pages router and app router
export default function useRouter() {
  const router = useContext(RouterContext);
  return router;
}
